import React, { useEffect, useState } from "react";
import { ptBR } from "date-fns/locale";
import * as S from "./styles";
import * as IconsSVG from "../../../../assets/iconsSVG";
import MaterialUI from "../../../../material-UI";
import { FilterDateRangeProps } from "./types";

const DatePickerRange: React.FC<FilterDateRangeProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabled,
  minDate,
  error,
  helperText,
}) => {
  const [dateError, setDateError] = useState<string | null>(null);

  useEffect(() => {
    // Verifica se a data final é anterior à data inicial
    if (startDate && endDate && endDate < startDate) {
      setDateError("A data final não pode ser anterior à data inicial");
      // Atualiza a data final para ser igual à inicial se for anterior
      onEndDateChange(startDate);
    } else {
      setDateError(null);
    }
  }, [startDate, endDate, onEndDateChange]);

  // Handler para mudança da data inicial
  const handleStartDateChange = (newValue: any) => {
    onStartDateChange(newValue);

    // Se a data final for anterior à nova data inicial, ajusta a data final
    if (endDate && newValue && endDate < newValue) {
      onEndDateChange(newValue);
    }
  };

  return (
    <S.LocalizationProvider
      locale={ptBR}
      dateAdapter={MaterialUI.AdapterDateFns}
    >
      <S.Row>
        <S.ContentDate>
          <S.DesktopDatePicker
            inputFormat="dd/MM/yyyy"
            value={startDate}
            components={{
              OpenPickerIcon: IconsSVG.CalendarIcon,
            }}
            disabled={disabled}
            InputAdornmentProps={{ position: "start" }}
            onChange={handleStartDateChange}
            renderInput={(params: any) => (
              <>
                <S.LabelText>De</S.LabelText>
                <S.TextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="De"
                  fullWidth
                />
              </>
            )}
          />
        </S.ContentDate>
        <S.ContentDate>
          <S.DesktopDatePicker
            inputFormat="dd/MM/yyyy"
            value={endDate}
            disabled={disabled}
            components={{
              OpenPickerIcon: IconsSVG.CalendarIcon,
            }}
            InputAdornmentProps={{ position: "start" }}
            onChange={(newValue: any) => onEndDateChange(newValue)}
            minDate={startDate || minDate}
            renderInput={(params: any) => (
              <>
                <S.LabelText>Até</S.LabelText>
                <S.TextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="Até"
                  fullWidth
                  error={!!dateError || error}
                  helperText={dateError || helperText}
                />
              </>
            )}
          />
        </S.ContentDate>
      </S.Row>
    </S.LocalizationProvider>
  );
};

export default DatePickerRange;
